import {useContext} from "react";
import {TimelineFrameInstructionsContext} from "./TimelineFrameContentInstructionsWrapper";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import Instructions from "../../../../../timeline/components/Instructions";
import CommonInstructions from "../../../../../timeline/components/CommonInstructions";
import {TYPE_FIMLAB, TYPE_VIDEO_CONFERENCE} from "../../../../../../definitions/TimelineItems";
import {TimelineFrameContentFimlabInstructions} from "./TimelineFrameContentFimlabInstructions";
import {FormattedMessage} from "react-intl";
import Row from "../../../../../../components/tag/Row";
import {isEmpty} from "lodash";

let { id: module_id } = module;
const TimelineFrameContentInstructions = () => {
    const { data } = useContext(TimelineFrameDataContext);
    const instructions = useContext(TimelineFrameInstructionsContext);

    const getAppointmentSpecificInstructions = () => {
        if (data.config && data.config.appointmentSpecificInstructions && !isEmpty(data.config.appointmentSpecificInstructions)) {
            if (data.type !== TYPE_FIMLAB) {
                return (
                    <>
                        <Row>
                            <p style={{marginBottom:"5px"}}>
                                <FormattedMessage id={`${module_id}.appointment.instruction.title`}
                                                  values={{
                                                      strong: (chunks) => <strong>{chunks}</strong>
                                                  }}
                                />
                            </p>
                            <Instructions instructions={data.config.appointmentSpecificInstructions} />
                        </Row>
                        <br/>
                    </>
                )
            }
        }
    }

    const getGenericInstructions = () => {
        let componentForRender = null;

        if (data.type === TYPE_FIMLAB) {
            return <TimelineFrameContentFimlabInstructions data={data}/>
        }

        if(data?.config?.type === "imaging" && data?.config?.instructions) {
            componentForRender =  <Instructions instructions={instructions}/>;
        }  else {
            componentForRender = <CommonInstructions instructions={instructions} />;
        }

        return (
            <Row>
                <p style={{marginBottom:"5px", fontWeight: "bold"}}>Sairaalassa asiointiin liittyvät ohjeet:</p>
                {componentForRender}
            </Row>
        );
    }

    return (
        <div className="instructions">
            { /* TODO: Refactor this implementation to be divided between fimlab and everything else */ }
            { /* TODO: Add conditional logic for appointment specific and generic instructions */ }
            {getAppointmentSpecificInstructions()}
            {getGenericInstructions()}
            {}
        </div>
    )

}

export default TimelineFrameContentInstructions;